import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M21 17L16 22L11 17L12.4 15.575L15 18.175L15 3H17V18.175L19.6 15.575L21 17ZM13 7L11.6 8.425L9 5.825V21H7L7 5.825L4.4 8.425L3 7L8 2L13 7Z" }, null, -1)
  ]))]))
}
export default { render: render }